export enum EuroSignPosition {
  Prefix = 'prefix',
  Suffix = 'suffix',
  None = 'none',
}

export function formatPrice(
  cost: number | null,
  includeDecimals: boolean,
  euroSignPosition: EuroSignPosition = EuroSignPosition.Prefix
) {
  if (cost == null) return '0';
  const formattedNumber = includeDecimals
    ? Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Math.round(cost * 100) / 100)
    : Intl.NumberFormat('de-DE').format(Math.round(cost));

  if (euroSignPosition === EuroSignPosition.None) {
    return formattedNumber;
  }

  const [prefix, suffix]: [string, string] =
    euroSignPosition === EuroSignPosition.Suffix
      ? ['', '\u00A0€']
      : ['€\u00A0', ''];

  return `${prefix}${formattedNumber}${suffix}`;
}
